

export const redirectUserToPaymentMethodCollectionPage = async (functionParameters = {}) => {
    
    const { getRedirectSmartbox } = (await import(/* webpackPrefetch: true */ "../../get/getRedirectSmartbox.js"));

    return getRedirectSmartbox({
        redirectCountDownSeconds:5,
        infoText:"txt1746",
        redirectUrl:null,
        fallbackFunctionDetails: {
            functionPath:"apps/paymentMethods/getCreditCardDetailsWithStripe",
            functionParameters
        }
    });


    // const { SmetioSmartbox } = (await import(/* webpackPrefetch: true */ "../../../classes/smetioSmartbox/v1.0.0/SmetioSmartbox.js"));

    // const { setTxtV2 } = (await import(/* webpackPrefetch: true */ "../../../classes/universal_methods/setTxtV2"));

    // const { getCreditCardDetailsWithStripe } = (await import(/* webpackPrefetch: true */ "./getCreditCardDetailsWithStripe"));

    // let redirectCountDownSeconds = 5;

    // const infoText = setTxtV2({
    //     attributes: {},
    //     txt: "txt1746",
    //     type: "html"
    // });

    // let redirectTimeText = setTxtV2({
    //     attributes: {},
    //     txt: "txt1747",
    //     type: "html"
    // });


    // redirectTimeText = redirectTimeText.replace("[#53c0nd5]", `<span style="font-size:150%;" class="smetio-redirect-times">${redirectCountDownSeconds}</span>`);
    
   
    // const smetioSmartbox = new SmetioSmartbox();
    // smetioSmartbox.title = functionParameters["title"];
    // smetioSmartbox.content = `
    //     <h4 class="smetio-h4-text-size">${infoText}</h4>

    //     <h2 class=" smetio-h2-text-size smetio-margin-top-40">${redirectTimeText}</h2>
    // `;
    // smetioSmartbox.render();

    // let timer = setInterval(() => {
    //     redirectCountDownSeconds = redirectCountDownSeconds - 1;

    //     $(".smetio-redirect-times").html(redirectCountDownSeconds);

    //     if (redirectCountDownSeconds < 1) {
    //         clearInterval(timer);
    //         return getCreditCardDetailsWithStripe(functionParameters);
    //     }

    // }, 1000);



};
